var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkout-complete" }, [
    _c("div", { staticClass: "text" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.booking.payment === _vm.PAYMENT_TYPES.ADVANCE
        ? _c("p", [_vm._v("\n      Thank you for your purchase.\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.booking.payment === _vm.PAYMENT_TYPES.ADVANCE_DEPOSIT
        ? _c("p", [_vm._v("\n      Thank you for your purchase.\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.booking.payment === _vm.PAYMENT_TYPES.VENUE
        ? _c("p", [_vm._v("\n      Thank you for your reservation.\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.booking.payment === _vm.PAYMENT_TYPES.NONE
        ? _c("p", [_vm._v("\n      Thank you for your order.\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.booking.user
        ? _c("p", [
            _vm._v("\n      We've sent a confirmation email to "),
            _c("strong", [_vm._v(_vm._s(_vm.booking.user.email))]),
            _vm._v(".\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n      Your order number is "),
        _c("strong", [_vm._v("#" + _vm._s(_vm.booking.id))]),
        _vm._v(".\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "items-wrapper" },
      [
        _c("label", [_vm._v("Items")]),
        _vm._v(" "),
        _c("checkout-items", { attrs: { complete: true } }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.tickets && _vm.tickets.length
      ? _c(
          "div",
          {
            staticClass: "tickets clearfix",
            class:
              ((_obj = {}),
              (_obj["total-tickets-" + _vm.tickets.length] = true),
              _obj),
          },
          [
            _c(
              "glider-carousel",
              {
                attrs: {
                  options: _vm.carouselOptions,
                  "item-width": 300,
                  arrows: _vm.tickets.length > 1,
                },
              },
              _vm._l(_vm.tickets, function (ticket, index) {
                return _c(
                  "div",
                  {
                    staticClass:
                      "ticket-wrapper animated fadeInUp col-xs-12 col-sm-6",
                  },
                  [
                    _c("div", { staticClass: "ticket" }, [
                      _c(
                        "div",
                        { staticClass: "ticket-top" },
                        [
                          _c("div", { staticClass: "ticket-qr-code center" }, [
                            _c("img", {
                              staticClass: "qr-code",
                              attrs: { src: ticket.qrCode },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("apple-wallet-button", {
                            attrs: {
                              booking: _vm.booking,
                              "ticket-id": ticket.id,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ticket-middle center" }, [
                        _c("div", { staticClass: "line" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "number" }, [
                          _vm._v(
                            "\n              Ticket " +
                              _vm._s(index + 1) +
                              " of " +
                              _vm._s(_vm.tickets.length) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ticket-bottom" }, [
                        _c("div", { staticClass: "ticket-cell" }, [
                          _c("label", [_vm._v("Name")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.booking.primaryUser.name) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.booking.event
                          ? _c("div", { staticClass: "ticket-cell" }, [
                              _c("label", [_vm._v("Event")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value ellipsize" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.booking.event.name) +
                                    "\n              "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "ticket-cell" }, [
                          _vm.booking.pickUpTimeInventory
                            ? _c("label", [_vm._v("Pick Up Time")])
                            : _c("label", [_vm._v("Ticket/seat")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value ellipsize" }, [
                            _vm.booking.pickUpTimeInventory
                              ? _c("span", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.booking.pickUpTimeInventory.name
                                      ) +
                                      "\n                "
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.booking.location) +
                                      "\n                "
                                  ),
                                ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "ticket-cell col-xs-6" }, [
                            _c("label", [_vm._v("Date")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("formatUTCDate")(
                                      _vm.booking.date,
                                      "ddd, MM/DD/YY"
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ticket-cell col-xs-6" }, [
                            _c("label", [_vm._v("Location")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.booking.venue.name) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                )
              })
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "icon-wrapper" }, [
        _c("i", { staticClass: "icon ion-checkmark-round" }),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("Order Complete!")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/CheckoutComplete/template.html?vue&type=template&id=65b2ec92&
// module id = 1036
// module chunks = 0